import { SecondaryPageLink } from '@/PageManager'
import { generateBech32IdFromATag, generateBech32IdFromETag, tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Content from '../Content'

export default function MergeRequest({ event, className }: { event: Event; className?: string }) {
  const { t } = useTranslation()
  const targetATag = useMemo(() => event.tags.find(tagNameEquals('a')), [event])
  const baseETag = useMemo(
    () => event.tags.find((tag) => tag[0] === 'e' && tag[3] !== 'source'),
    [event]
  )
  const sourceETag = useMemo(
    () => event.tags.find((tag) => tag[0] === 'e' && tag[3] === 'source'),
    [event]
  )
  const targetNaddr = useMemo(
    () => (targetATag ? generateBech32IdFromATag(targetATag) : undefined),
    [targetATag]
  )
  const targetIdentifier = targetATag ? targetATag[1].split(':')[2] : undefined
  const baseNevent = useMemo(
    () => (baseETag ? generateBech32IdFromETag(baseETag) : undefined),
    [baseETag]
  )
  const sourceNevent = useMemo(
    () => (sourceETag ? generateBech32IdFromETag(sourceETag) : undefined),
    [sourceETag]
  )

  return (
    <div className={cn('space-y-2', className)}>
      <div className="font-medium">{t('Merge request')}</div>
      {event.content && <Content event={event} />}
      <div className="space-y-1 text-sm text-muted-foreground">
        {targetNaddr && (
          <div>
            <span className="font-medium text-foreground">{t('Target')}: </span>
            <SecondaryPageLink
              to={`/${targetNaddr}`}
              className="text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {targetIdentifier || targetNaddr}
            </SecondaryPageLink>
          </div>
        )}
        {baseNevent && (
          <div>
            <span className="font-medium text-foreground">{t('Base')}: </span>
            <SecondaryPageLink
              to={`/${baseNevent}`}
              className="text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {baseNevent}
            </SecondaryPageLink>
          </div>
        )}
        {sourceNevent && (
          <div>
            <span className="font-medium text-foreground">{t('Source')}: </span>
            <SecondaryPageLink
              to={`/${sourceNevent}`}
              className="text-primary hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {sourceNevent}
            </SecondaryPageLink>
          </div>
        )}
      </div>
    </div>
  )
}
